module.exports = __webpack_public_path__ + "media/בת.fb14cbac.mp3";